<template>
    <router-link
            :to="{ name: 'challenge-details', params: { slug: challengeGroup.slug }, query: {technology: getTechnologyQuery(firstTechnologyInList)} }">
        <div class="panel panel-clickable campaign-link col-lg-12"
             :class="{'active-challenge-group': challengeGroup.isAccepted && !challengeGroup.isSolved,'solved-challenge-group': challengeGroup.isAccepted && challengeGroup.isSolved}">
            <div class="panel-heading">
                <div v-if="challengeGroup.isOnboardingChallengeGroup && !userHasSolvedAtLeastOneChallenge" class="onboarding-challenge-header">
                    <strong>Perfekt</strong> für den <strong>Einstieg</strong>
                </div>
                <div v-if="challengeGroup.isNew" class="onboarding-challenge-header is-new">
                    <strong v-if="challengeGroup.id !== '6ac87c7a-1bb5-4b6c-938e-635917a7f04f'">NEU</strong>
                    <strong v-if="challengeGroup.id === '6ac87c7a-1bb5-4b6c-938e-635917a7f04f'">WETTBEWERB
                        <Countdown class="countdown" deadline="February 19, 2020 16:00:00"></Countdown>
                    </strong>
                </div>
            </div>

            <div class="panel-body"
                 v-bind:class="{ 'sponsor-footer': sponsoredChallenge || (!sponsoringInformationLoaded && isAuthenticated), 'panel-body-with-sponsoring': sponsoredChallenge || (!sponsoringInformationLoaded && isAuthenticated)}">
                <div class="text-center col-md-12 col-sm-12 panel-image">
                    <img class="img-responsive center-block" :src="challengeGroup.image"
                         :alt="'An icon for the ' + challengeGroup.title + ' challenge'">
                </div>
                <div class="col-md-12 col-sm-12 panel-content">
                    <h3 class="challenge-title">
                        <strong>{{ challengeGroup.title }} </strong>
                    </h3>
                    <div class="challenge-group-information">
                        <span class="difficulty-level">
                            <img :src="'https://res.cloudinary.com/dspi5zyaa/image/upload/v1638971079/eh-platform/icons/difficulties/' + difficulties[challengeGroup.complexity - 1].icon + '.svg'"
                                 alt="difficulty-level">{{ difficulties[challengeGroup.complexity - 1].name }}
                        </span>
                        <span>&#8226;</span>
                        <span class="reward">{{ maxRewardPossible }}<img
                                src="https://polylith-public-files.s3.eu-central-1.amazonaws.com/icons/Coins-Flat.png"
                                alt="An icon with coins"></span>
                        <span>&#8226;</span>
                        <span class="category">{{ category }}</span>

                    </div>
                    <p v-html="challengeGroup.description"></p>

                    <div class="availabe-in">
                        verfügbar in:
                    </div>
                    <div class="challenge-group-languages-wrapper" v-for="programmingTechnology of technologyList">
                        <router-link
                                :to="{ name: 'challenge-details', params: { slug: challengeGroup.slug }, query: {technology: getTechnologyQuery(programmingTechnology) }}"
                                class="direct-challenge-link">
                            <div class="challenge-group-languages" :key="programmingTechnology.id"
                                 :class="{
                                    'bg-python': programmingTechnology.language.toLocaleLowerCase() === 'python',
                                    'bg-dockerfile': programmingTechnology.language.toLocaleLowerCase() === 'dockerfile',
                                    'bg-java': programmingTechnology.language.toLocaleLowerCase() === 'java',
                                    'bg-javascript': programmingTechnology.language.toLocaleLowerCase() === 'javascript',
                                    'bg-csharp': programmingTechnology.language.toLocaleLowerCase() === 'csharp',
                                    'bg-cpp': programmingTechnology.language.toLocaleLowerCase() === 'cpp',
                                    'bg-php': programmingTechnology.language.toLocaleLowerCase() === 'php',
                                    'bg-abap': programmingTechnology.language.toLocaleLowerCase() === 'abap',
                                    'bg-kotlin': programmingTechnology.language.toLocaleLowerCase() === 'kotlin',
                                    'bg-powershell': programmingTechnology.language.toLocaleLowerCase() === 'powershell',
                                    'bg-rust': programmingTechnology.language.toLocaleLowerCase() === 'rust',
                                }">
                                <i class="dev-icon dev-code-slash"></i>
                                <span class="technology-label">{{ getTechnologyDisplayName(programmingTechnology).toUpperCase() }}</span>
                            </div>
                        </router-link>
                    </div>
                </div>
                <div class="clearfix"></div>
                <div class="sponsor" v-if="sponsoredChallenge">
                    <p>Gesponsert durch
                        <strong>{{sponsoredChallenge.name }}</strong>
                    </p>
                    <img :alt="'Challenge sponsored by ' + sponsoredChallenge.name" :src="logoOfSponsor"
                         class="logo-box"/>
                </div>
                <div class="sponsor" v-if="!sponsoringInformationLoaded && isAuthenticated">
                    <content-loader
                            style="position: absolute; top: 0; left: 0; width: 100% !important; height:100% !important;"
                            :height="50" :width="1000" height="100%" width="100%">
                        <rect width="100%" height="100%"></rect>
                    </content-loader>
                </div>
            </div>
        </div>
    </router-link>
</template>

<script>
    import {mapState} from 'vuex';
    import {DIFFICULTIES, LANGUAGES} from "../../const";
    import {ContentLoader} from "vue-content-loader";
    import Countdown from "vuejs-countdown";
    import {getTechnologyQuery} from "../../services/Utilities";

    export default {
        name: "ChallengeGroupComponent",
        components: {
            ContentLoader, Countdown
        },
        data() {
            return {
                difficulties: DIFFICULTIES,
                firstTechnologyInList: {},
                technologyList: [],
            }
        },
        props: {
            challengeGroup: {type: [Object], default: {}},
            sponsoredChallenge: {type: [Object], default: null},
            sponsoringInformationLoaded: {type: [Boolean], default: false},
            userHasSolvedAtLeastOneChallenge: {type: [Boolean], default: false},
        },
        computed: {
            logoOfSponsor() {
                if (!this.sponsoredChallenge) {
                    return '';
                }
                if (this.sponsoredChallenge.logoIcon) {
                    return this.sponsoredChallenge.logoIcon;
                }
                return this.sponsoredChallenge.logo;
            },
            category() {
                if (this.challengeGroup.type === 'CHALLENGE') {
                    return "#story";
                }
                if (this.challengeGroup.type === 'REAL_TASK') {
                    return "#echteaufgabe";
                }
                if (this.challengeGroup.type === 'INTERVIEW_TEST') {
                    return "#algorithmus";
                }
                if (this.challengeGroup.type === 'TRAINING') {
                    return "#training";
                }
            },
            maxRewardPossible() {
                if (this.sponsoredChallenge) {
                    return this.challengeGroup.rewardSponsored;
                }
                return this.challengeGroup.rewardInteract;
            },

            ...mapState([
                'isAuthenticated',
            ]),
        },
        watch: {
          'challengeGroup': function() {
            this.createTechnologyList();
          },
        },
        methods: {
            createTechnologyList() {
                this.technologyList = [];
                for (let challenge of this.challengeGroup.challenges) {
                    if (challenge.deactivated) {
                        continue;
                    }
                    this.technologyList.push(challenge.technology);
                }
                this.firstTechnologyInList = this.technologyList[0];
            },
            getTechnologyDisplayName(technology) {
                let programmingLanguage = technology.language.toLocaleLowerCase();
                if (programmingLanguage === "") {
                    return this.name;
                }
                if (technology.name === "") {
                    return LANGUAGES[programmingLanguage];
                }
                return LANGUAGES[programmingLanguage] + " (" + technology.name + ")";
            },
            getTechnologyQuery: getTechnologyQuery,
        },
        created() {
            this.createTechnologyList();
        }
    }
</script>

<style scoped>
    a:hover {
      text-decoration: none;
    }

    .solved-challenge-group:before {
        content: "\f00c";
        font: normal normal normal 14px/1 FontAwesome;
        color: whitesmoke;
        display: block;
        width: 5rem;
        height: 5rem;
        line-height: 5rem;
        border-radius: 50%;
        background: linear-gradient(to bottom right, #08AB99 0%, #0BC4A2 100%);
        position: absolute;
        right: 25px;
        top: 25px;
        box-shadow: 0 2px 4px rgba(173, 181, 189, 0.15);
        font-size: 2rem;
        text-align: center;
    }

    .active-challenge-group:before {
        content: "\f04c";
        font: normal normal normal 14px/1 FontAwesome;
        color: whitesmoke;
        display: block;
        width: 5rem;
        height: 5rem;
        line-height: 5rem;
        border-radius: 50%;
        background: linear-gradient(to bottom right, #fa8231 0%, #f7b731 100%);
        position: absolute;
        right: 25px;
        top: 25px;
        box-shadow: 0px 2px 4px rgba(173, 181, 189, 0.15);
        font-size: 2rem;
        text-align: center;
    }

    .panel-heading {
      text-align: center;
    }

    .onboarding-challenge-header.is-new {
        color: #d35400;
    }

    .new-editor-label {
      line-height: 10px;
      padding: 1rem 2rem;
      border-radius: 10px;
      margin: .5rem auto;
      background-color: #2b86c5;
      background-image: linear-gradient(19deg, #2b86c5 0%, #B721FF 100%);
      font-weight: 600;
      box-shadow: 0 0 0 0 rgba(43, 134, 197, 1);
	    transform: scale(1);
	    animation: pulse 2s infinite;
      display: inline-block;
    }

    @keyframes pulse {
      0% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(43, 134, 197, 0.7);
      }

      70% {
        transform: scale(1);
        box-shadow: 0 0 0 10px rgba(43, 134, 197, 0);
      }

      100% {
        transform: scale(0.95);
        box-shadow: 0 0 0 0 rgba(43, 134, 197, 0);
      }
    }

    .new-editor {
      color: white;
      font-size: 1.4rem;
      width: 100%;
    }

    .panel-body-with-sponsoring {
        padding-bottom: 130px;
    }

    .panel-content {
        padding: 3rem 0 0 0;
    }

    .panel-image {
        margin-top: 3rem;
    }

    .img-responsive {
        height: 100px;
    }

    .challenge-title {
        margin-bottom: 0.7rem;
        font-size: 19.5px;
        font-weight: 300;
        line-height: 1.4;
    }

    @media (max-width: 768px) {
        .challenge-title {
            font-size: 18px;
            margin-bottom: 0;
        }
    }

    .challenge-coins img {
        height: 1.2rem;
    }

    .challenge-complexity h3 {
        font-size: 15px;
        text-align: center;
    }

    .logo-box {
        padding: 3px;
        display: block;
        margin: 0 auto;
        max-height: 50px;

    }

    .sponsor {
        padding: 1.4rem 1rem 2rem 1rem;
        background-color: var(--color-light);
        text-align: center;
        position: absolute;
        height: 120px;
        bottom: 0;
        left: 0;
        width: 100%;
        border-radius: 0 0 10px 10px;
    }

    .onboarding-challenge-header {
        margin-left: -15px;
        margin-right: -15px;
        text-align: center;
        color: #2980b9;
        font-size: 2rem;
    }

    .challenge-group-information {
        color: grey;
    }

    .challenge-group-information > span {
        color: grey;
        margin-right: 1rem;
    }

    .challenge-group-languages:hover {
        box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
        -webkit-transform: scale(1.1);
        transform: scale(1.1);
    }

    .challenge-group-languages-wrapper {
        position: relative;
        display: inline-block;
    }

    .challenge-group-languages {
        font-family: "Source Code Pro", sans-serif;
        color: white;
        overflow: hidden;
        padding: 3px 20px;
        margin-bottom: 2px;
        border-radius: 100px;
        background-color: grey;
        margin-right: 1rem;
        line-height: 1.6;
        -webkit-transform: perspective(1px) translateZ(0);
        transform: perspective(1px) translateZ(0);
        box-shadow: 0 0 1px rgba(0, 0, 0, 0);
        -webkit-transition-duration: 0.3s;
        transition-duration: 0.3s;
        -webkit-transition-property: box-shadow, transform;
        transition-property: box-shadow, transform;
    }

    .challenge-group-languages > .dev-icon {
        position: absolute;
        bottom: -20%;
        left: -8%;
        font-size: 28px;
        color: rgba(255, 255, 255, 0.15);
    }

    .difficulty-level img {
        max-width: 30px;
        margin-bottom: 0.5rem;
        margin-right: 0.8rem;
    }

    @media (max-width: 768px) {
        .difficulty-level img {
            max-width: 25px;
            margin-bottom: 0.4rem;
            margin-right: 0.5rem;
        }
    }

    .availabe-in {
        font-size: 12px;
        color: grey;
        margin-bottom: 1rem;
    }

    .reward img {
        width: 12px;
        height: auto;
        margin-bottom: 0.4rem;
        margin-left: 0.5rem;
    }

    .category img {
        max-width: 18px;
        margin-right: 0.5rem;
        margin-bottom: 0.3rem;
    }

    .technology-label {
        font-size: 11px;
    }

    a.direct-challenge-link:hover {
        text-decoration: none;
    }

    a:focus {
        text-decoration: none;
    }
</style>

